import React, { useEffect, useState } from 'react';

// Ordine di chiamata e avvio della fase.
//
// I due comandi ora sono uno solo: `start_phase` porta con se l'ordine, e il
// server lo applica sotto lo stesso lock. Prima partivano separati, e se
// l'ordine veniva rifiutato la fase cominciava lo stesso — con quello vecchio.

/** L'elenco da mostrare: la disposizione in corso, altrimenti l'ordine salvato
 *  sul server, altrimenti l'ordine d'ingresso. Chi non c'e piu cade, chi e
 *  arrivato dopo si accoda: quello che il banditore aveva gia composto non si
 *  butta via a ogni aggiornamento. */
function arrange(participants, turnOrder, previous) {
    const present = new Map(participants.map((participant) => [participant.id, participant]));
    const base = previous.length ? previous.map((participant) => participant.id) : turnOrder ?? [];
    const kept = base.filter((id) => present.has(id));
    const seen = new Set(kept);
    return [
        ...kept.map((id) => present.get(id)),
        ...participants.filter((participant) => !seen.has(participant.id)),
    ];
}

export default function AuctioneerLobby({
    participants,
    turnOrder,
    phaseRole,
    expectedParticipants,
    onStartPhase,
}) {
    const [order, setOrder] = useState(() => arrange(participants, turnOrder, []));

    // Le dipendenze sono il *contenuto*, non l'identita degli array: ogni
    // evento del server ne consegna di nuovi, e prima bastava che qualcuno si
    // collegasse per riazzerare la disposizione appena composta dal banditore.
    const roster = participants.map((p) => `${p.id}:${p.name}`).join('|');
    const saved = (turnOrder ?? []).join('|');
    useEffect(() => {
        setOrder((previous) => arrange(participants, turnOrder, previous));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [roster, saved]);

    const move = (index, direction) => {
        const next = [...order];
        const [moved] = next.splice(index, 1);
        next.splice(index + direction, 0, moved);
        setOrder(next);
    };

    const missing = expectedParticipants - participants.length;

    return (
        <div className="panel">
            <div className="panel-header">
                <h3 className="panel-title">Controlli dell&apos;Asta</h3>
            </div>
            <div className="panel-body">
                <h4>Ruolo attuale: {phaseRole}</h4>
                <h4>Ordine di chiamata:</h4>
                <ul className="list">
                    {order.map((participant, index) => (
                        <li key={participant.id} className="list-item">
                            <span className="turn-slot">
                                <span className="turn-number num">{index + 1}</span>
                                <span className="u-truncate">{participant.name}</span>
                            </span>
                            <div className="btn-group">
                                <button
                                    type="button"
                                    className="btn btn--ghost btn--icon"
                                    onClick={() => move(index, -1)}
                                    disabled={index === 0}
                                    aria-label={`Sposta ${participant.name} in alto`}
                                >
                                    ↑
                                </button>
                                <button
                                    type="button"
                                    className="btn btn--ghost btn--icon"
                                    onClick={() => move(index, 1)}
                                    disabled={index === order.length - 1}
                                    aria-label={`Sposta ${participant.name} in basso`}
                                >
                                    ↓
                                </button>
                            </div>
                        </li>
                    ))}
                </ul>
                <button
                    type="button"
                    className="btn btn--primary"
                    onClick={() => onStartPhase(order.map((participant) => participant.id))}
                    disabled={missing > 0}
                >
                    Salva ordine e inizia la fase {phaseRole}
                </button>
                {missing > 0 && (
                    <p className="u-dim">
                        In attesa di {missing} partecipant{missing === 1 ? 'e' : 'i'}.
                    </p>
                )}
            </div>
        </div>
    );
}
